import { Box, styled } from "@mui/material";

export const OverviewTableFilter = styled(Box)({
  display: "flex",
  gap: 16,
});
